module.exports = __webpack_public_path__ + "bf.no2.67ca30a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bf.no2.jpg
// module id = Ec0N
// module chunks = 0